import classNames from "../../utils";
 
const BlockOne = ({ data }) => {


  return (
    <div className="px-20 pb-0 md:pb-12 pt-6 h-[60vh] sm:h-[80vh] md:h-[160vh]">
      <div className="hidden lg:flex flex-col justify-center items-center mb-4">
        <h1 className="text-darkBg dark:text-lightBg text-xl md:text-7xl font-bold font-custom">{data?.title}</h1>
      </div>
      <div className="flex flex-col md:flex-row gap-x-10 justify-center items-center">
  <img
    className="max-w-[200px] md:max-w-[600px] max-h-[400px]"
    src={data?.about_us_image}
    alt="about"
  />

  <p
    className={classNames(
      'myHtml text-xl text-darkBg text-center dark:text-lightBg mt-6 md:mt-12 leading-10 font-customFamily font-normal md:max-w-[610px] min-w-[325px] md:min-w-[610px]'
    )}
    dangerouslySetInnerHTML={{ __html: data?.description || '' }}
  />
</div>

      </div>
  )
}

export default BlockOne